const timerId = new Map();
export function debouncePromise(fn, time) {
    // this hash should avoid potential conflicts with usage of `debouncePromise` from an other caller
    const hash = btoa(fn.toString());
    if (timerId.has(hash)) {
        clearTimeout(timerId.get(hash));
    }
    return new Promise((resolve) => {
        timerId.set(hash, setTimeout(() => resolve(fn()), time));
    });
}
